module.exports = __webpack_public_path__ + "img/pic-4.5cf2324f.png";